import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from "@azure/msal-react";
import { EventType } from "@azure/msal-browser";
import { msalInstance } from "./msalConfig";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Sync login/logout across tabs using sessionStorage (cleared on tab close)
const authChannel = new BroadcastChannel("auth");
authChannel.onmessage = ({ data }) => {
  if (data === "logout") {
    msalInstance.clearCache().then(() => window.location.replace("/"));
  } else if (data === "login") {
    window.location.reload();
  }
};

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) authChannel.postMessage("login");
  if (event.eventType === EventType.LOGOUT_END) authChannel.postMessage("logout");
});

// Initialize MSAL and handle redirect
msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().then((response) => {
    if (response) {
      // User just logged in via redirect
      const account = response.account;
      msalInstance.setActiveAccount(account);
    }
  }).catch((error) => {
    console.error('Redirect error:', error);
  });

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );

  reportWebVitals();
}).catch((error) => {
  console.error('MSAL initialization error:', error);
});
